export default "__VITE_ASSET__DwfzzK7e__"